import axios from '@/jslib/axios'
import {productAPiPath} from '@/utils/smePath'
export const getQuoteAll = data => {
  return axios({
    method: 'post',
    url: '/admin/quote/all',
    data
  })
}

export const getQuoteAllNew = data => {
  return axios({
    method: 'post',
    url: '/admin/quote/all/new',
    data,
    timeout: 60000
  })
}

// 保存報價
export const saveQuotation = data => {
  return axios({
    method: 'post',
    url: '/admin/quotation/save',
    data
  })
}

export const getCarModelOptions = params => {
  return axios({
    method: 'get',
    url: '/admin/quote/car/model',
    params
  })
}
export const getQuoteDetail = (params,productId=11) => {
  return axios({
    method: 'get',
    url: `/admin/order/${productAPiPath[productId]}/quote/detail`,
    params
  })
}
export const getCarQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/car/quote/detail',
    params
  })
}

export const getHousemaidQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/housemaid/quote/detail',
    params
  })
}

export const getInteriorQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/interior/quote/detail',
    params
  })
}

export const getHomefireQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/home_fire/quote/detail',
    params
  })
}
export const getTravelQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/travel/quote/detail',
    params
  })
}
export const getStudentQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/student/quote/detail',
    params
  })
}
export const getWorkingQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/holiday/quote/detail',
    params
  })
}
export const getPersonalQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/accident/quote/detail',
    params
  })
}
export const getDroneQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/drone/quote/detail',
    params
  })
}
export const getCoressQuoteDetail = (params,product_id = 11) => {
  return axios({
    method: 'get',
    url: `/admin/order/${productAPiPath[product_id]}/quote/detail`,
    params
  })
}

export const getPetQuoteDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/pet/quote/detail',
    params
  })
}
// 編輯報價結果
export const editQuoteResult = data => {
  return axios({
    method: 'post',
    url: '/admin/quote/edit/result',
    data
  })
}
export const paymentLinkSend = data =>{
  return axios({
    method: 'post',
    url: '/admin/payment/link/send',
    data
  })
}

export const signLinkSend = data =>{
  return axios({
    method: 'post',
    url: '/admin/sign/link/send',
    data
  })
}

export const getQuoteShare = data =>{
  return axios({
    method: 'post',
    url: '/admin/quote/share',
    data
  })
}

export const orderCsSet = data =>{
  return axios({
    method: 'post',
    url: '/admin/order/cs/set',
    data
  })
}
export const orderSkip = data =>{
  return axios({
    method: 'post',
    url: '/admin/order/skip/sign',
    data
  })
}

export const getQuoteReference = (url, data) => {
  return axios({
    method: 'post',
    responseType: 'blob',
    url,
    data,
    timeout: 120000
  })
}
export const quoteRemarkAdd = data => {
  return axios({
    method: 'post',
    url: '/admin/quote/remark/add',
    data
  })
}

export const downloadQuotePdf = (url, data) => {
  return axios({
    method: 'post',
    url,
    data,
    responseType: 'blob'
  })
}

export const getQuoteUrl = params => {
  return axios({
    method: 'get',
    url: '/admin/order/quote/url',
    params
  })
}

export const setDiscount = data => {
  return axios({
    method: 'post',
    url: '/admin/share/guest/set/discount',
    data
  })
}
export const downReferApplication = data => {
  return axios({
    method: 'post',
    url: '/admin/refer/friend/download/application',
    data
  })
}

export const getQuoteCarRelation = params => {
  return axios({
    method: 'get',
    url: '/admin/quote/car/relation',
    params
  })
}
export const quoteSentStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/sent/change/status',
    data
  })
}
